import React, { useEffect, useState } from 'react';
import { observer } from "mobx-react-lite";
import { Grid } from '@material-ui/core';
import {Element} from "react-scroll"
import AccountSelect from '@components/dumb/AccountSelect';
import AccountForm from '@components/dumb/AccountForm';
import { useMedia } from '@commons/media';
import { useTranslation } from 'react-i18next';
import RootStore from '@stores';
import AccountShareV2 from '@components/dumb/AccountShareV2';
import './index.scss'
import wx from 'weixin-js-sdk';

interface AccountProps {

}

const Account: React.FC<AccountProps> = observer(()=> {
    const {i18n} = useTranslation();
    const language = i18n.language
    const {mediaClass} = useMedia()
    const [select, setSelect] = useState(0)
    const [isLogin, setIsLogin] = useState(false)
    const {
        portalContent
    } = RootStore.PortalStore;
    const {
        jwt_token,
        mgmRefferCode
    } = RootStore.BasicInfoStore;

    const [mgmAccounts, setMgmAccounts] = useState({})
    const [mgmShares, setMgmShares] = useState({})

    // if token set login status
    // useEffect(() => {
    //     if (jwt_token) {
    //         setIsLogin(true);
    //     }
    // }, [jwt_token]);

    useEffect(() => {
        mgmRefferCode && setIsLogin(true)
        console.log('mgmRefferCode--1--', mgmRefferCode)
        console.log('wx.miniProgram--1-', wx.miniProgram)
        if (!mgmRefferCode) return;
          
        // 确保在微信小程序 WebView 环境中
        if (typeof wx !== 'undefined' && wx.miniProgram) {
            wx.miniProgram.postMessage({
            data: { refferCode: mgmRefferCode }
            });
            console.log('post message----', mgmRefferCode)
        } else {
            console.error('当前环境不支持 wx.miniProgram');
        }
    }, [mgmRefferCode])

    useEffect(() => {
        let langMgmAccounts = i18n.getResource(language, "portal", "mgmAccounts")
        let langMgmShares = i18n.getResource(language, "portal", "mgmShares")
        if (langMgmAccounts) {
            setMgmAccounts(langMgmAccounts)
        }
        if (langMgmShares) {
            setMgmShares(langMgmShares)
            console.log(langMgmShares, 'mgmShares');
        }
    }, [portalContent, language, i18n])

    const changeSelect = (status:number) => {
        setSelect(status)
    }

    const confirmLogin = (status:boolean) => {
        setIsLogin(status)
    }

    const signOut = () => {
        setIsLogin(false);
    }
    
    return (
        <Element name="account">
            <Grid container className={`${mediaClass('account-wrapper')}`} justifyContent='center'>
            {
                <React.Fragment>
                    <AccountSelect mgmAccounts={mgmAccounts} select={select} onChange={changeSelect}></AccountSelect>
                    {
                        !isLogin ? 
                        <AccountForm mgmAccounts={mgmAccounts} select={select} isLogin={isLogin} confirmLogin={confirmLogin}></AccountForm>
                        :
                        <AccountShareV2 mgmShares={mgmShares} mgmAccounts={mgmAccounts} select={select}></AccountShareV2>
                    }
                </React.Fragment>
                // isLogin ? (
                //         <AccountShare mgmShares={mgmShares} signOut={signOut}></AccountShare>
                // ) : (

                // )
            }
            </Grid>
        </Element>
    )
})

export default Account;
